// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";

import { Loading, MessageBox, Message, Notification } from "element-ui";
import element from "element-ui";

import "element-ui/lib/theme-chalk/index.css";
import * as commonApi from "./utils/common";
import util from "@/lib/util";
import cache from "@/lib/cache";
import config from "@/common/config";
import utils from "@/common/util.js";
import VueRouter from "vue-router";
import center from "@/api/center.api";
import home from "@/api/home.api";
import html2canvas from "html2canvas";
import BaiduMap from "vue-baidu-map";
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";

//引入拖拽排序插件
import VueDND from "awe-dnd";
// 引入vue-meta插件用于SEO优化
import VueMeta from 'vue-meta';

Vue.use(VueDND);
Vue.use(VueMeta);
Vue.use(ViewUI);
const api = {
  center: center,
  home: home
};
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: "GhXGvY1uujhuRYTq7UzuZDSmseOZabIy"
});
Vue.use(element);
Vue.use(Loading.directive);
Vue.use(VueRouter);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;

Vue.prototype.$config = config;
Vue.prototype.$util = new util();
Vue.prototype.$utils = utils;
Vue.prototype.$commonApi = commonApi;
Vue.prototype.$cache = new cache(`TSB_`);
Vue.prototype.$api = api;

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js